import { createPortal } from 'react-dom';

function ReactPortal({ children }) {
  return createPortal(children, document.getElementById('finesseIMIGadget'));
}
export default ReactPortal;